import { NgModule } from '@angular/core';
import { ClientConfiguration } from 'src/app/app.config';
import { PermissionsGuard } from 'src/app/shared/authorization/permissions.guard';
import { PermissionsService } from 'src/app/shared/authorization/permissions.service';
import { AircraftAutocompleteComponent } from 'src/app/shared/components/aircraft-autocomplete/aircraft-autocomplete.component';
import { BaseAutocompleteComponent } from 'src/app/shared/components/base-autocomplete/base-autocomplete.component';
import { BrowserNoticeComponent } from 'src/app/shared/components/browser-notice/browser-notice.component';
import { FlightLogActionsComponent } from 'src/app/shared/components/flight-log-action-buttons/flight-log-action-buttons.component';
import { MultiQuantityControlComponent } from 'src/app/shared/components/multi-quantity-control/multi-quantity-control.component';
import { TcsModule } from 'src/app/shared/tcs/tcs.module';
import { ModuleWithProvidersStrict } from 'src/util/angular/ng-core';
import { AircraftAutocompleteV2Component } from './components/aircraft-autocomplete-v2/aircraft-autocomplete-v2.component';
import { AlertDialogComponent } from './components/alert-dialog/alert-dialog.component';
import { AutocompleteHelperComponent } from './components/autocomplete-helper/autocomplete-helper.component';
import { BaseAutocompleteV2Component } from './components/base-autocomplete-v2/base-autocomplete-v2.component';
import { DateRangePickerComponent } from './components/date-range-picker/date-range-picker.component';
import { DefaultLayoutComponent } from './components/default-layout/default-layout.component';
import { DefinitionListComponent } from './components/definition-list/definition-list.component';
import { DutyStatusButtonComponent } from './components/duty-status-button/duty-status-button.component';
import { EmployeeAutocompleteComponent } from './components/employee-autocomplete/employee-autocomplete.component';
import { FlightLogHighlightsTableComponent } from './components/flight-log-highlights-table/flight-log-highlights-table.component';
import { FlightLogSummariesTableComponent } from './components/flight-log-summaries-table/flight-log-summaries-table.component';
import { MaintenanceDueListComponent } from './components/maintenance-due-list/maintenance-due-list.component';
import { MaintenanceImageControlComponent } from './components/maintenance-image-control/maintenance-image-control.component';
import { MultiQuantitySelectComponent } from './components/multi-quantity-select/multi-quantity-select.component';
import { SaveIndicatorComponent } from './components/save-indicator/save-indicator.component';
import { SwitchUserDialogComponent } from './components/switch-user-dialog/switch-user-dialog.component';
import { SharedBaseModule } from './shared-base/shared-base.module';

const exportedImports = [SharedBaseModule];

const exportedDeclarations = [
  DefinitionListComponent,
  FlightLogActionsComponent,
  DateRangePickerComponent,
  DefaultLayoutComponent,
  MaintenanceDueListComponent,
  MaintenanceImageControlComponent,
  DutyStatusButtonComponent,
  MultiQuantitySelectComponent,
  SaveIndicatorComponent,
  BrowserNoticeComponent,
  MultiQuantityControlComponent,
  BaseAutocompleteComponent,
  AircraftAutocompleteComponent,
  FlightLogSummariesTableComponent,
  EmployeeAutocompleteComponent,
  BaseAutocompleteV2Component,
  AircraftAutocompleteV2Component,
  AlertDialogComponent,
  FlightLogHighlightsTableComponent,
  SwitchUserDialogComponent,
];

const exportedProviders = [PermissionsService, PermissionsGuard];

// providers should be defined via forRoot for root shared module
@NgModule({
  imports: exportedImports,
  declarations: [...exportedDeclarations, AutocompleteHelperComponent, AlertDialogComponent],
  exports: [...exportedDeclarations, ...exportedImports],
  providers: [...exportedProviders],
  entryComponents: [AlertDialogComponent, SwitchUserDialogComponent],
})
export class SharedModule {
  public static forRoot(config: ClientConfiguration): ModuleWithProvidersStrict {
    return {
      ngModule: SharedModule,
      providers: [
        ...SharedBaseModule.forRoot().providers,
        ...TcsModule.forRoot(config.tcs).providers,
      ],
    };
  }
}
